import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTripadvisorComponent } from './simple-icons-tripadvisor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTripadvisorComponent ],
    exports:      [ SimpleIconsTripadvisorComponent ],
    bootstrap:    []
})
export class SimpleIconsTripadvisorModule {}
